/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  BatchImportSubsystemsRequestDto,
  CreateSubsystemRequestDto,
  ListSubsystemsResponseDto,
  SubsystemOneResponseDto,
  SubsystemResponseDto,
  UpdateSubsystemRequestDto,
} from '../models/index';
import {
    BatchImportSubsystemsRequestDtoFromJSON,
    BatchImportSubsystemsRequestDtoToJSON,
    CreateSubsystemRequestDtoFromJSON,
    CreateSubsystemRequestDtoToJSON,
    ListSubsystemsResponseDtoFromJSON,
    ListSubsystemsResponseDtoToJSON,
    SubsystemOneResponseDtoFromJSON,
    SubsystemOneResponseDtoToJSON,
    SubsystemResponseDtoFromJSON,
    SubsystemResponseDtoToJSON,
    UpdateSubsystemRequestDtoFromJSON,
    UpdateSubsystemRequestDtoToJSON,
} from '../models/index';

export interface SubsystemControllerBatchImportRequest {
    batchImportSubsystemsRequestDto: BatchImportSubsystemsRequestDto;
}

export interface SubsystemControllerCreateRequest {
    createSubsystemRequestDto: CreateSubsystemRequestDto;
}

export interface SubsystemControllerDeleteRequest {
    id: string;
}

export interface SubsystemControllerFindAllRequest {
    limit: number;
    page: number;
    q?: string;
}

export interface SubsystemControllerFindByIdRequest {
    id: string;
}

export interface SubsystemControllerUpdateRequest {
    id: string;
    updateSubsystemRequestDto: UpdateSubsystemRequestDto;
}

/**
 * 
 */
export class KnowledgeBaseSubsystemsApi extends runtime.BaseAPI {

    /**
     */
    async subsystemControllerBatchImportRaw(requestParameters: SubsystemControllerBatchImportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['batchImportSubsystemsRequestDto'] == null) {
            throw new runtime.RequiredError(
                'batchImportSubsystemsRequestDto',
                'Required parameter "batchImportSubsystemsRequestDto" was null or undefined when calling subsystemControllerBatchImport().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/subsystems/batch-import`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: BatchImportSubsystemsRequestDtoToJSON(requestParameters['batchImportSubsystemsRequestDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async subsystemControllerBatchImport(requestParameters: SubsystemControllerBatchImportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.subsystemControllerBatchImportRaw(requestParameters, initOverrides);
    }

    /**
     */
    async subsystemControllerCreateRaw(requestParameters: SubsystemControllerCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SubsystemResponseDto>> {
        if (requestParameters['createSubsystemRequestDto'] == null) {
            throw new runtime.RequiredError(
                'createSubsystemRequestDto',
                'Required parameter "createSubsystemRequestDto" was null or undefined when calling subsystemControllerCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/subsystems`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateSubsystemRequestDtoToJSON(requestParameters['createSubsystemRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SubsystemResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async subsystemControllerCreate(requestParameters: SubsystemControllerCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SubsystemResponseDto> {
        const response = await this.subsystemControllerCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async subsystemControllerDeleteRaw(requestParameters: SubsystemControllerDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling subsystemControllerDelete().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/subsystems/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async subsystemControllerDelete(requestParameters: SubsystemControllerDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.subsystemControllerDeleteRaw(requestParameters, initOverrides);
    }

    /**
     */
    async subsystemControllerFindAllRaw(requestParameters: SubsystemControllerFindAllRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListSubsystemsResponseDto>> {
        if (requestParameters['limit'] == null) {
            throw new runtime.RequiredError(
                'limit',
                'Required parameter "limit" was null or undefined when calling subsystemControllerFindAll().'
            );
        }

        if (requestParameters['page'] == null) {
            throw new runtime.RequiredError(
                'page',
                'Required parameter "page" was null or undefined when calling subsystemControllerFindAll().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['q'] != null) {
            queryParameters['q'] = requestParameters['q'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/subsystems`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListSubsystemsResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async subsystemControllerFindAll(requestParameters: SubsystemControllerFindAllRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListSubsystemsResponseDto> {
        const response = await this.subsystemControllerFindAllRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async subsystemControllerFindByIdRaw(requestParameters: SubsystemControllerFindByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SubsystemOneResponseDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling subsystemControllerFindById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/subsystems/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SubsystemOneResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async subsystemControllerFindById(requestParameters: SubsystemControllerFindByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SubsystemOneResponseDto> {
        const response = await this.subsystemControllerFindByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async subsystemControllerUpdateRaw(requestParameters: SubsystemControllerUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SubsystemResponseDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling subsystemControllerUpdate().'
            );
        }

        if (requestParameters['updateSubsystemRequestDto'] == null) {
            throw new runtime.RequiredError(
                'updateSubsystemRequestDto',
                'Required parameter "updateSubsystemRequestDto" was null or undefined when calling subsystemControllerUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/subsystems/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateSubsystemRequestDtoToJSON(requestParameters['updateSubsystemRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SubsystemResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async subsystemControllerUpdate(requestParameters: SubsystemControllerUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SubsystemResponseDto> {
        const response = await this.subsystemControllerUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
